import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'app/global/global.service';
import { ConvertToEformSettings } from 'app/main/pages/edit-template/edit-template.dto';

@Component({
  selector: 'app-agree-terms-and-conditions',
  templateUrl: './agree-terms-and-conditions.component.html',
  styleUrl: './agree-terms-and-conditions.component.scss'
})
export class AgreeTermsAndConditionsComponent {
  @Input() termsAndCondition!: ConvertToEformSettings;
  constructor(public activeModal:NgbActiveModal, private globalService:GlobalService){}
}
